module.exports = __webpack_public_path__ + "img/nodecision.ea2dc389.svg";